import React from 'react';

const ButtonDinamyc = (props: { message: string, classes: string, action: void | any, dataTest?: string, disable?:boolean }) => {
  return (
    <>
      <button
        data-test={props.dataTest}
        type="button"
        disabled = {props.disable}
        className={`btn ${props.classes}`}
        onClick={props.action} >
          { props.message } 
      </button>
    </>
  )
}

export default ButtonDinamyc
